import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from "react-router-dom";
// import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';

import * as billPaymentActions from "store/entities/billPayment/action";

import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import Maybe from 'components/__new/common/Maybe';
import useLoginInfo from 'hooks/useLoginInfo';
import { SelectInput } from 'components/__new/common/form';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
// import SearchableBillPaymentProviders from '../Providers';
import BillPaymentProviders from 'components/__new/billPayment/BillPaymentProviders';
import { electricityPurchaseValidation } from 'store/entities/billPayment/action';

import transformBillerInput from 'utils/transformBillerInputWithKey';
import useTransformedProviders from 'hooks/useTransformedProviders';
import { ButtonLoader } from 'components/__new/common/form';
import { ReactComponent as IconSearch } from "assets/images/icons/icon-search.svg";
import { ReactComponent as IconEmptyBox } from "assets/images/icons/project-icons/empty-box.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { REGEX_VALUES } from 'utils/regexValues';


const SinglePowerPurchase = ({ togglePurchaseModal, initiatePurchase, defaultParams, generateClientReference, selectSingleBeneficiary, setSelectSingleBeneficiary }) => {
    const dispatch = useDispatch()
    const {userInfo} = useLoginInfo();
    const location = useLocation();
    const {urlQueryParams} = useUrlQueryParams();
    
    const { electricityValidationLoading: isValidating, electricityValidation: validatedData } = useSelector((s) => s.entities.billPayment);    
    const [validatedMeter, setValidatedMeter] = useState(null);

    const [form, setForm] = useState({
        network: {},
        amount: 0,
        accountType: "",
        account: "",
        name: "",
        address: "",
        phone: "",
    });
    
    const [listParams, setListParams] = useState({
        page: 1,
        limit: 20
    });
    
    const billPaymentProvidersRef = useRef()
    
    const [beneficiariesShown, setBeneficiariesShown] = useState(false);
    const { beneficiariesLoading, beneficiaries } = useSelector((s) => s.entities.billPayment);
    const { electricityPurchaseLoading } = useSelector((s) => s.entities.billPayment);    
    const { providers, providersLoading } = useSelector((state) => state.entities.billPayment)
    
    const handleAccountChange = (e) => {
        const { value } = e.target;
        if(REGEX_VALUES.NUMBERS_ONLY.test(value)){
            return;
          }
        if ((value.length !== 14) && (value >= 0)) {
            setForm({...form, account: value})
        } 
    }
    
    const handlePhoneChange = (e) => {
        const { value } = e.target;
        if(REGEX_VALUES.NUMBERS_ONLY.test(value)){
            return;
          }
        if ((value.length !== 12) && (value >= 0)) {
            setForm({...form, phone: value})
        } 
    }
    
    const handleAmountChange = (val) => {
        if(val < 0){
            setForm({...form, amount: val * -1})
        }
        else if ((val.length !== 15) && (val >= 0)) {
                setForm({...form, amount: val.toFixed()})
        }
    }
    
    
    const getAllBeneficiaries = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(billPaymentActions.getAllBeneficiaries({...params, service: "electricity", businessId: userInfo?.employer?._id }))
    }
    
    const handleSelectedBeneficiary = (beneficiary) => { 
        setBeneficiariesShown(prev => !prev)     
        setSelectSingleBeneficiary({...beneficiary})
        // add more functions to manipulate beneficiaries
        
    }
    
    // const closePurchaseModal = () => {
    //     togglePurchaseModal();
    // }
    
    const updateSinglePurchaseForm = () => {
        const user = selectSingleBeneficiary
        const biller = transformBillerInput(providers?.response?.electricity, user?.product)
        const updatedForm = { ...form, account: user?.meterNumber, accountType: user?.meterType, network: biller, name: user?.alias, service: "electricity" }
        setForm(updatedForm)
    }
    
    const proceedToPurchase = (e) => {
        e.preventDefault();
        
        const params = {
                ...defaultParams,
                account: form.account,
                amount: parseInt(form.amount) * 100,
                phone: form.phone,
                service: form.network?.value,
                accountType: form.accountType,
                name: form.name,
                address: form.address,
                clientReference: generateClientReference(form.phone),
                memberId: userInfo?.member?._id
            }
            togglePurchaseModal();
            setSelectSingleBeneficiary({
                meterNumber: form.account,
                meterType: form.accountType,
                phoneNumber: form.phone,
                product: form.network?.value,
            })
            initiatePurchase(params);
    }
    
    
    useEffect(() => {
        if((form?.account?.length === 11 || form?.account?.length === 13) && form?.accountType?.length && form?.network?.value?.length) {
            const params = {
                account: form.account,
                accountType: form.accountType,
                service: form.network?.value,
                userId: userInfo.employer._id,
            }
            
            dispatch(electricityPurchaseValidation(params));
        }
        // eslint-disable-next-line
    }, [form?.account, form?.accountType, form?.network])
    
    
    useEffect(() => {
        if(validatedData?.status === 'success') {
            setValidatedMeter(validatedData?.response);
            setForm({
                ...form,
                name: validatedData?.response?.name,
                address: validatedData?.response?.address
            })
        }
        // eslint-disable-next-line
    }, [validatedData])
    
    useEffect(() => {
        setValidatedMeter(null);
    }, [])
    
      
    useEffect(() => {
        getAllBeneficiaries();
    }, [location]);
    
    // recent
    const {transformedData: biller, setTransformedData: setBiller} = useTransformedProviders(providers?.response?.electricity, selectSingleBeneficiary?.product)
    // const {transformedData: biller, setTransformedData: setBiller} = useTransformedProviders(providers?.response?.electricity, user?.product)
    
    useEffect(() => {
        if(biller){
            // setForm({...currentValue});
            billPaymentProvidersRef.current?.setSelectedOption(biller)
            setBiller(null)
        }
    }, [biller, setBiller]);
    
    useEffect(() => {
        updateSinglePurchaseForm()
    }, [selectSingleBeneficiary]);
    
    
    const handleCloseModal = () => {
        togglePurchaseModal();
        setForm({});
        setValidatedMeter(null);
    }    
    
    
    const disableSubmit = !form?.network?.label?.length ||
    !(form?.account?.length === 11 || form?.account?.length === 13) || !form?.amount?.length || !validatedMeter || form?.phone?.length < 11;
    
    return (
        <div className='w-full'>
            <form onSubmit={proceedToPurchase}>
                <div className="w-full">
                    
                    <div className="relative">
                    <BillPaymentProviders
                                type="electricity"
                                label="Biller"
                                tag="products"
                                providersLoading={providersLoading} 
                                providers={providers}
                                ref={billPaymentProvidersRef}
                                onValueChange={(e) => {
                                    setForm({...form, network: e, amount: "", account: ""});
                                    setValidatedMeter(null);
                                }}
                            />
                        {/* <SearchableBillPaymentProviders
                            type="electricity"
                            label="Biller"
                            tag="products"
                            ref={searchableBillPaymentProvidersRef}
                            onValueChange={(e) => {
                                setForm({...form, network: e, amount: "", account: ""});
                                setValidatedMeter(null);
                            }}
                        /> */}
                        
                        <div onClick={() => setBeneficiariesShown(!beneficiariesShown)} className='text-sm cursor-pointer border-b border-ep-primary-600 text-ep-primary-600 absolute -bottom-6'>
                            {beneficiariesShown ? "Close search" : "Or Search Beneficiary List"}
                        </div>
                    </div>
                    
                    <div className="mt-10">
                        <SelectInput label="Meter Type" value={form.accountType} onChange={(e) => {setForm({...form, accountType: e.target.value})}}>
                            <option value="" disabled>Select</option>
                            <option value="prepaid">Prepaid</option>
                            <option value="postpaid">Postpaid</option>
                        </SelectInput>
                    </div>
                    
                    <div className='form-group relative'>
                        <label>Meter Number</label>
                        <input
                            type="text"
                            id="prl-input"
                            className="form-input"
                            value={form.account}
                            placeholder="Enter Meter Number"
                            min={0}
                            // onChange={(e) => setForm({...form, account: e.target.value})}
                            onChange={handleAccountChange}
                            
                        />
                        
                        <Maybe condition={validatedMeter !== null}>
                            <div className="w-full flex items-center justify-start absolute -bottom-7">
                                <div className="flex items-center text-sm">
                                    <IconCheckCircle width={15} />
                                    <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedMeter?.name?.toLowerCase()}</div>
                                </div>
                            </div>
                        </Maybe>
                    </div>
                    
                    <div className='my-10' />
                    
                    <div className="form-group">
                        <label>Phone Number</label>
                        <input
                            type="text"
                            id="prl-input"
                            className="form-input"
                            value={form.phone || ""}
                            placeholder="Enter Phone Number"
                            onChange={handlePhoneChange}
                            min={0}
                            // onChange={(e) => setForm({...form, phone: e.target.value})}
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Amount</label>
                        <input
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form.amount}
                            placeholder="0.00"
                            min={0}
                            onChange={(e) => handleAmountChange(Number(e.target.value))}
                        />
                    </div>
                </div>
                
                <div className="border-t w-full flex items-center justify-end mt-4 pt-3">
                    <button type="button" onClick={handleCloseModal} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <ButtonLoader loading={electricityPurchaseLoading} type="submit" disabled={disableSubmit} className="btn btn-ep-primary">
                        {isValidating ? "Validating..." : "Purchase"}
                    </ButtonLoader>
                </div>
            </form>
            <Maybe condition={beneficiariesShown}>
                <BeneficiariesList
                    userInfo={userInfo}
                    loading={beneficiariesLoading}
                    handleSelectedBeneficiary={handleSelectedBeneficiary}
                    beneficiaries={beneficiaries?.data?.docs}
                    beneficiariesLoading={beneficiariesLoading}
                />
            </Maybe>
        </div>
    )
}


const BeneficiariesList = ({handleSelectedBeneficiary, beneficiariesLoading, beneficiaries}) => {
    
    
    const [keyword, setKeyword] = useState("");
    
    const filteredBeneficiaries = beneficiaries?.filter((beneficiary) => {
        if(keyword === "") {
            return true
        } else {
            return beneficiary?.product?.toLowerCase()?.includes(keyword?.toLowerCase()) ||
                    beneficiary?.meterNumber?.toLowerCase()?.includes(keyword?.toLowerCase()) ||
                    beneficiary?.alias?.toLowerCase()?.includes(keyword?.toLowerCase())
        }
    })
    
    return (
        <div style={{
                position: "absolute",
                right: "-340px",
                height: "300px",
                top: "-25px" 
            }}
            className="overflow-y-scroll text-sm modal-list-wrap bg-white top-0 w-[300px] rounded-lg">
            
            <Maybe condition={beneficiariesLoading === true}>
                <div className="py-5 text-center mt-8">
                    <div className="font-medium">
                        Fetching beneficiaries
                    </div>
                    <div className="mt-4 flex justify-center">
                        <FontAwesomeIcon icon="circle-notch" spin className="text-2xl" />
                    </div>
                </div>
            </Maybe>
            
            
            <Maybe condition={beneficiariesLoading === false && beneficiaries?.length === 0}>
                <div className="py-5 w-full flex items-center justify-center flex-col mt-14">
                    <IconEmptyBox />
                    <div className="font-medium text-sm mb-2">
                        No beneficiaries have been added yet
                    </div>
                    <Link to="/payments/beneficiaries/electricity" target="_blank" className="underline text-ep-primary">
                        Click here to add a new beneficiary
                    </Link>
                </div>
            </Maybe> 
            
            
            <Maybe condition={beneficiariesLoading === false && beneficiaries?.length > 0}>
                <div className="w-full bg-white sticky top-0 left-0 p-4">
                    <div className="w-full relative">
                        <input
                            type="text"
                            value={keyword}
                            placeholder='Search Beneficiaries' 
                            onChange={(e) => setKeyword(e.target.value)}
                            className='bg-[#f3f4f6] w-full relative text-xs pl-9 !border-0 !ring-0 rounded-lg form-input'
                        />
                        
                        <IconSearch className='absolute left-2 top-2.5' width={18} />
                    </div>
                </div>
                
                <div className="w-full p-4 pt-1">
                    <div>
                        {filteredBeneficiaries?.map((beneficiary, index) => ( 
                            <div onClick={() => handleSelectedBeneficiary(beneficiary)} key={beneficiary?._id} className="mb-2.5 pb-2 border-b cursor-pointer">
                                <div className="font-medium capitalize text-[#374151]">{beneficiary?.alias?.toLowerCase() || '-'}</div>
                                
                                <div className="flex items-center pt-1 text-gray-500">
                                    <div>{beneficiary?.meterNumber}</div>
                                    <span className='h-1 w-1 rounded-full bg-gray-500 mx-1' />
                                    <div className="uppercase">{beneficiary?.product}</div>
                                </div>
                            </div>
                            )
                        )}
                    </div>
                </div>
            </Maybe>
            
            <div className='sticky bottom-0 h-2 bg-white w-full left-0' />
        </div>
    )
}


export default SinglePowerPurchase